import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Layouts from 'layouts';
import { I18nextProvider } from "react-i18next";    
import i18n from "./i18n";
import { Provider } from "react-redux";

import store from 'reducers';

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <Layouts />
        </Provider>
    </I18nextProvider>, 
document.getElementById('root'));